import React, {useMemo} from 'react';
import {Table} from "antd";
import UserDiscipline from "../../../models/UserDiscipline";
import {useProject} from "../../../providers/ClientProjectProvider";
import {useProjectScope} from "./ProjectScopeProvider";

const ProjectDisciplinesTable = ({size = "middle", className = "", ...props}) => {
    const {
        project
    } = useProject();
    const {scope, isDisabled} = useProjectScope();


    const disciplineData = useMemo(() => {
        let phaseDisciplinesById = TB.groupBy(
            TB.flatMap(
                TB.flatMap(
                    TB.filter(
                        TB.flatMap(
                            scope?.phases || [],
                            'deliverables'
                        ), ['is_active', true]
                    ), 'activities'
                ), 'disciplines'
            ),
        'id')

        return TB.map([...(project.disciplines || [])], discipline => {
            let market_rate = UserDiscipline.rateForDiscipline(discipline.id, project.percent_markup, true) || 0;
            let active_hours = 0;

            if (phaseDisciplinesById[discipline.id]) {
                active_hours = TB.sumBy(phaseDisciplinesById[discipline.id], dis => parseInt(dis.total_hours || 0))
            }
            let estimated_platform_cost = Math.ceil(market_rate) * active_hours;

            return {...discipline, estimated_platform_cost, active_hours, market_rate};
        })
    }, [isDisabled, scope]);



    return (
        <div className={className + " flex flex-col gap-6 items-stretch"}>
            <Table
                rowKey="id"
                dataSource={disciplineData}
                summary={(pageData) => {
                    let totalHours = TB.sumBy(pageData, 'active_hours');
                    let totalEstCost = TB.sumBy(pageData, 'estimated_platform_cost');

                    return (
                        <Table.Summary.Row className="bg-gray-300">
                            <Table.Summary.Cell index={0}>
                                <p className="text-sm font-medium">
                                    Total
                                </p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                                <p className="text-sm font-medium">
                                    {totalHours} hrs
                                </p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}>

                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3}>
                                <p className="text-sm font-medium">
                                    {TB.formatCurrency(totalEstCost, false)}
                                </p>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
                bordered
                size="small"
                pagination={false}>


                <Table.Column
                    title="Roles"
                    dataIndex="name"
                    render={name => (
                        <p className="text-xs whitespace-nowrap">
                            {name}
                        </p>
                    )}
                />
                <Table.Column
                    title="Est. Hours"
                    dataIndex="active_hours"
                    width={100}
                    render={active_hours => (
                        <p className={"text-xs whitespace-nowrap"}>
                            {active_hours || 0}
                        </p>
                    )}
                />
                <Table.Column
                    title="Market Rate"
                    dataIndex="market_rate"
                    width={140}
                    render={market_rate => (
                        <p className="text-xs whitespace-nowrap">
                            {TB.formatCurrency(market_rate, false)}/hr
                        </p>
                    )}
                />
                <Table.Column
                    title="Est. Cost"
                    dataIndex="estimated_platform_cost"
                    width={120}
                    render={estimated_platform_cost => (
                        <p className="text-xs whitespace-nowrap">
                            {TB.formatCurrency(estimated_platform_cost, false)}
                        </p>
                    )}
                />

            </Table>
        </div>
    );
};

export default ProjectDisciplinesTable;